import React from "react";
import FormControl from "../../components/formControl";
import CustomDropdown from "../../components/presentationals/CustomDropdown";
import { Button, TextField } from "@material-ui/core";
import TableName from "./sections/tableName";
// import WorkFlow from "./sections/workFlow";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function OperationalDB(props) {
  const {
    setSelectedDateFrom,
    tilesData,
    schemaName,
    updateDropValue,
    selectedFormData,
    tableTypeObj,
    onSubmit,
    operationalDashObj,
    // workFlowObj,
    selectedDateFrom,
  } = props;
  return (
    <div className="container-fluid">
      <div className="whitebox mt-sm-5 mb-1">
        <form autoComplete="off">
          <FormControl variant="outlined" type="form" styleName="formControl">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Date"
                inputFormat="DD-MMM-YYYY"
                value={selectedDateFrom}
                maxDate={new Date()}
                onChange={(date) => setSelectedDateFrom(date)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    error={
                      !dayjs(selectedDateFrom).isValid() ||
                      dayjs(selectedDateFrom).isAfter(new Date(), "day")
                    }
                    helperText={
                      !dayjs(selectedDateFrom).isValid()
                        ? "Invalid Date Format."
                        : dayjs(selectedDateFrom).isAfter(new Date())
                        ? "Date cannot be after today's date"
                        : null
                    }
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 11,
                    }}
                  />
                )}
                margin="normal"
              />
            </LocalizationProvider>
          </FormControl>

          {/* </FormControl> */}
          <FormControl variant="outlined" type="form" styleName="formControl">
            <CustomDropdown
              name={"Database"}
              data={schemaName.length > 0 ? schemaName : ["No data available"]}
              changeHandler={(value) => updateDropValue("dashboard", value)}
              value={selectedFormData.dashboard}
            />
          </FormControl>
          {/* <FormControl variant="outlined" type="form" styleName="formControl">
            <CustomDropdown
              name={"Table Type"}
              data={tableTypeObj?.data}
              loading={tableTypeObj.loading}
              changeHandler={(value) => updateDropValue("tableType", value)}
              value={selectedFormData.tableType}
            />
          </FormControl> */}
          <FormControl variant="outlined" type="form" styleName="formControl">
            <Button
              onClick={(e) => onSubmit()}
              variant="contained"
              color="default"
              disabled={
                !dayjs(selectedDateFrom).isValid() ||
                dayjs(selectedDateFrom).isAfter(new Date(), "day")
              }
            >
              Run
            </Button>
          </FormControl>
        </form>
      </div>

      <h2
        className="pagetitle wow fadeInUp"
        data-wow-delay=".5s"
        data-wow-duration="0.7s"
      >
        Operational Dashboard
      </h2>

      <TableName operationalDashObj={operationalDashObj} />
      {/* <WorkFlow workFlowObj={workFlowObj} /> */}

      {/* {
        //if data is there for operational dashboard, show data
        getAllAPI &&
        !isEmptyObject(getAllAPI.data) &&
        getAllAPI.data.content &&
        getAllAPI.data.content[6] ? (
          <>
            <TableName operationalDashObj={operationalDashObj} />
            <WorkFlow workFlowObj={workFlowObj} />
          </>
        ) : // else if getAllAPI is still loading, show Spinner

        getAllAPI && getAllAPI.loading ? (
            <Spinner />
        ) : (
          //else there is error in getting api
          <div
            className="whitebox wow fadeInUp"
            data-wow-delay=".6s"
            data-wow-duration="0.7s"
          >
            Unable to fetch data
          </div>
        )
      } */}
    </div>
  );
}

export default OperationalDB;

//         &&
// return (
//   <TableName operationalDashObj={operationalDashObj} />
//       <WorkFlow workFlowObj={workFlowObj} />
// )

// :

// getAllAPI && getAllAPI.loading ?  return (
//             <Spinner />
// )

// :
// return (<div
//             className="whitebox wow fadeInUp"
//             data-wow-delay=".6s"
//             data-wow-duration="0.7s"
//           >
//             Unable to fetch data
//           </div>)
